import React from 'react';

function BrandLogo({ className = 'brand-logo' }) {
  // Stylized "0<" mark — eye-shaped 0 + chevron V.
  // Two color slots; .bl-eye and .bl-chev pick up color via currentColor.
  return (
    <svg
      className={className}
      viewBox="0 0 88 50"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      stroke="currentColor"
      strokeWidth="3.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <g className="bl-eye">
        <rect x="2" y="2" width="32" height="46" rx="16" ry="16" />
        <ellipse cx="18" cy="25" rx="3.6" ry="5" fill="currentColor" stroke="none" />
      </g>
      <polyline className="bl-chev" points="86,5 44,25 86,45" />
    </svg>
  );
}

export default BrandLogo;
